import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { apiBase } from './workspace';

/** Better Auth client (cookies; same origin in dev through the Vite proxy). */
export const authClient = createAuthClient({
  baseURL: apiBase || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5182'),
  basePath: '/api/auth',
  fetchOptions: { credentials: 'include' },
  plugins: [magicLinkClient()],
});

export type SessionData = typeof authClient.$Infer.Session;

/** Fetch the current session (null when signed out). Used by route guards. */
export async function fetchSession(): Promise<SessionData | null> {
  const res = await authClient.getSession();
  return res.data ?? null;
}
